import React from "react";
import Image from "next/image";
import styles from "./Login.module.less";
import logo from "@aspen/assets/images/aspen_logo_white.webp";
import { handleBlur, handleFocus, i18nUtil } from "@aspen/libs";
import LanguageSwitch from "./LanguageSwitch";
import clsx from "clsx";

export const LoginLayoutCMS = WrappedComponent => {
  const LoginCMS = props => {
    const intl = i18nUtil.t();

    return (
      <section className={clsx(styles.login, "login")}>
        <LanguageSwitch />
        <div className={styles.main}>
          <div className={styles.mainContainer}>
            <section className={styles.leftBriefBlack}>
              <span className={styles.logo}>
                <Image unoptimized src={logo} alt="logo" />
              </span>
              <p className={styles.title}>{intl["login.title.CMS"]}</p>
            </section>
            <WrappedComponent {...props} handleFocus={handleFocus} handleBlur={handleBlur} />
          </div>
        </div>
      </section>
    );
  };

  return LoginCMS;
};
